import type { BeforeSendFn, Properties } from 'posthog-js';

// Auth0 (and other OAuth-style redirects, e.g. the email integration setup flow)
// append these to the callback URL. They must never reach PostHog.
const SENSITIVE_QUERY_PARAMS = [
    'code',
    'state',
    'token',
    'access_token',
    'id_token',
    'refresh_token',
    'client_secret',
    'otl',
    'ticket',
];

const URL_PROPERTY_KEYS = [
    '$current_url',
    '$referrer',
    '$initial_current_url',
    '$initial_referrer',
    'href',
    '$session_entry_url',
];

function stripSensitiveParams(rawUrl: string): string {
    let url: URL;
    try {
        url = new URL(rawUrl, window.location.origin);
    } catch {
        return rawUrl;
    }

    let changed = false;
    SENSITIVE_QUERY_PARAMS.forEach((param) => {
        if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            changed = true;
        }
    });

    return changed ? url.toString() : rawUrl;
}

function sanitizeUrlProperties(properties: Properties | undefined | null): void {
    if (!properties) {
        return;
    }
    URL_PROPERTY_KEYS.forEach((key) => {
        const value = properties[key];
        if (typeof value === 'string') {
            properties[key] = stripSensitiveParams(value);
        }
    });
}

export const sanitizeSensitiveUrlParams: BeforeSendFn = (event) => {
    if (!event) {
        return event;
    }
    sanitizeUrlProperties(event.properties);
    sanitizeUrlProperties(event.$set);
    sanitizeUrlProperties(event.$set_once);
    return event;
};
